import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
const toggler = document.querySelector(".main-nav__toggle");
const header = document.querySelector(".header");

const links = header.querySelectorAll(".main-nav__link");

// аргументы setupModal(modal, closeCallback, modalBtns, openCallback, noPrevDefault, preventScrollLock)
// возможна инициализация только с первыми аргументом,
// если вам нужно открывать модалку в другом месте под какими-нибудь условиями

for (let link of links) {
  link.addEventListener("click", () => {
    if (screen.width < 768) {
      toggler.click();
    }
  });
}

const openHeader = () => {
  header.classList.toggle("header--opened");

  if (header.classList.contains("header--opened")) {
    disableBodyScroll(header);
  } else {
    enableBodyScroll(header);
  }
};

const initToggler = () => {
  toggler.addEventListener("click", openHeader);
};

export { initToggler };
